module.exports = __webpack_public_path__ + "fonts/HalisR-S-Light.5b269394.otf";